import { useEffect } from 'react';

export function useReveal(dep?: any) {
  useEffect(() => {
    // Adding a slight delay to ensure DOM is fully rendered
    const timeout = setTimeout(() => {
      const els = document.querySelectorAll('.reveal');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach((el) => io.observe(el));
      return () => io.disconnect();
    }, 100);

    return () => clearTimeout(timeout);
  }, [dep]);
}
